import styled from 'styled-components';

export const SidePanelContainer = styled.div`
	display: flex;
	width: 28.25rem;
	padding: 1rem 0rem;
	flex-direction: column;
	align-items: flex-start;
	border-radius: 0rem 0.25rem 0rem 0rem;
	border-left: 1px solid var(--Colour-greys-4, #d3d8da);
	padding: 1rem;
`;

export const FileTableContainer = styled.div`
	display: flex;
	padding: 1rem;
	flex-direction: column;
	gap: 0.5rem;
	flex: 1;
`;

export const FileSelectorContainer = styled.div`
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 0.5rem;
`;

export const FileItemContainer = styled.div<{ $isSelected: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	border-radius: 0.25rem;
	border: 1px solid ${({ $isSelected }) => ($isSelected ? '#B6CEFB' : '#D3D8DA')};
	background: ${({ $isSelected }) => ($isSelected ? '#E7EFFE' : 'transparent')};
`;

export const FileItemInnerContainer = styled.div`
	display: flex;
	padding: 0.5rem;
	gap: 0.5rem;
	align-items: flex-start;
`;
